// extracted by mini-css-extract-plugin
export var cardContainer = "_o8-0";
export var cardHeader = "_o8-2";
export var collapsedState = "_o8-3";
export var dragHandle = "_o8-5";
export var dragHandleIcon = "_o8-6";
export var dragging = "_o8-1";
export var titleArea = "_o8-4";